const RECOVERY_STORAGE_KEY = 'sso:chunk-load-recovery-urls'

const CHUNK_LOAD_ERROR_PATTERNS = [
  /(?:failed to fetch|error loading) dynamically imported module/i,
  /importing a module script failed/i,
  /chunkloaderror/i,
  /loading (?:css )?chunk \S+ failed/i,
  /failed to load module script/i,
  /expected a javascript(?:-or-wasm)? module script.*mime type/i,
  /not (?:a )?valid javascript mime type/i,
  /loading module .*blocked.*mime type/i,
  /mime type.*(?:not executable|strict mime type checking|mismatch)/i
]

export function isChunkLoadError(error) {
  if (!error) return false

  const message =
    typeof error === 'string' ? error : [error.name, error.message].filter(Boolean).join(' ')

  return CHUNK_LOAD_ERROR_PATTERNS.some((pattern) => pattern.test(message))
}

function getAbsoluteUrl(route, location) {
  const path = route && route.fullPath ? route.fullPath : location.href
  return new URL(path, location.href).href
}

function readAttemptedUrls(storage) {
  const value = storage.getItem(RECOVERY_STORAGE_KEY)
  if (!value) return []

  const urls = JSON.parse(value)
  return Array.isArray(urls) ? urls : []
}

export function createChunkLoadRecovery({ storage, location }) {
  function recover(error, route) {
    if (!isChunkLoadError(error)) return false

    try {
      const url = getAbsoluteUrl(route, location)
      const attemptedUrls = readAttemptedUrls(storage)

      if (attemptedUrls.includes(url)) return false

      const nextValue = JSON.stringify([...attemptedUrls, url])
      storage.setItem(RECOVERY_STORAGE_KEY, nextValue)

      // Some privacy modes fail storage writes without throwing.
      if (storage.getItem(RECOVERY_STORAGE_KEY) !== nextValue) return false

      location.replace(url)
      return true
    } catch (error) {
      return false
    }
  }

  function clearAfterNavigation(failure) {
    if (failure) return

    try {
      storage.removeItem(RECOVERY_STORAGE_KEY)
    } catch (error) {
      // A storage failure here is harmless and must not affect navigation.
    }
  }

  return { recover, clearAfterNavigation }
}
